import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import InviteeFollowEmailLinkCard from 'features/Onboarding/legacy/components/InviteeFollowEmailLinkCard';

const RedirectBeneficiaryInvitee = asBentoPage(({ Layout, onPrev }) => (
  <Layout nav={<OBNavigation onPrev={onPrev} />}>
    <InviteeFollowEmailLinkCard />
  </Layout>
));

export default RedirectBeneficiaryInvitee;
